import { useState, useEffect } from "react";
import { CONFERENCE } from "@/data/content";

function getRemaining(target) {
  const diff = new Date(target).getTime() - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, done: true };
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    minutes: Math.floor((diff / 60000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    done: false,
  };
}

export default function Countdown({ light = false }) {
  const [t, setT] = useState(() => getRemaining(CONFERENCE.countdownTarget));

  useEffect(() => {
    const id = setInterval(() => setT(getRemaining(CONFERENCE.countdownTarget)), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { v: t.days, l: "Days" },
    { v: t.hours, l: "Hrs" },
    { v: t.minutes, l: "Min" },
    { v: t.seconds, l: "Sec" },
  ];

  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div className="flex items-center gap-3 sm:gap-4" data-testid="hero-countdown">
      {units.map((u, i) => (
        <div key={u.l} className="flex items-center gap-3 sm:gap-4">
          <div className="text-center">
            <div
              className={`font-mono text-3xl sm:text-5xl font-bold tabular-nums ${
                light ? "text-white" : "text-ink"
              }`}
            >
              {pad(u.v)}
            </div>
            <div
              className={`font-mono text-[10px] sm:text-xs uppercase tracking-[0.25em] mt-1 ${
                light ? "text-white/60" : "text-ink/50"
              }`}
            >
              {u.l}
            </div>
          </div>
          {i < units.length - 1 && (
            <span className={`text-2xl sm:text-4xl font-light -mt-4 ${light ? "text-crimson" : "text-crimson"}`}>:</span>
          )}
        </div>
      ))}
    </div>
  );
}
